export enum OcbSftpAuthenticationModes {
    Password = 0,
    SshKey = 1
}
